import request from "@/util/request"
import qs from "qs"

export function getNewsList(type, nowPage) {
  return request({
    url: `/api/news?type=${type}&nowPage=${nowPage}`
  })
}
export function getHome() {
  return request({
    url: `/api/home`
  })
}

export function getNews(id) {
  return request({
    url: `/api/news/${id}`
  })
}

export function getSchoolCalendar(nowPage) {
  return request({
    url: `/api/schoolCalendar?nowPage=${nowPage}`
  })
}

export function getTeacher(type, nowPage) {
  return request({
    url: `/api/teacher?type=${type}&nowPage=${nowPage}`
  })
}

export function getOtherBanner() {
  return request({
    url: `/api/otherBanner`
  })
}

export function getCodeImg() {
  return request({
    url: `/api/validateCode`
  })
}

export function signUp(student) {
  return request({
    url: `/api/student`,
    method: 'post',
    params: student
  })
}

export function getMenus() {
  return request({
    url: `/api/menus`
  })
}

export function getSubMenu(id) {
  return request({
    url: `/api/subMenu/${id}`
  })
}

export function getThirdMenu(id) {
  return request({
    url: `/api/thirdMenu/${id}`
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js